import React from "react";
import { MainDiv } from "../../components/Profile/Profile.style";
import Menu from "../../components/Security/Menu/Menu";
import { VolunteerHeading } from "../../components/Volunteer/Volunteer.style";

const MenuSetupPage = () => {
  return (
    <MainDiv>
      <VolunteerHeading>Module Setup</VolunteerHeading>
      <Menu />
    </MainDiv>
  );
};

export default MenuSetupPage;
